import { z } from 'zod'
import { Timestamp } from './common.js'
import { RoutePublic } from './route.js'

const UserLevel = z.number().int().min(1).max(6)

export const SystemNotification = z.discriminatedUnion('kind', [
  z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    kind: z.literal('level_upgraded'),
    from_level: UserLevel,
    to_level: UserLevel,
    created_at: Timestamp,
    read_at: Timestamp.nullable(),
  }),
  z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    kind: z.literal('route_published'),
    route: RoutePublic.pick({ id: true, slug: true, title: true }),
    created_at: Timestamp,
    read_at: Timestamp.nullable(),
  }),
])
export type SystemNotification = z.infer<typeof SystemNotification>
